// We are using react for some part in the framework. (comments, forms)
// So make sure these work if you override this
import 'xp-lib-brand/react/main-react';
import Mount from 'xp-lib-brand/react/utils/mount';

const cta = () => import(/* webpackChunkName: "cta" */ './modules/cta/cta.jsx');
Mount('.member-cta-button', cta, ['description', 'buttonText', 'destination', 'btnClass', 'gaTag', 'showArrowIcon', 'target']);
